import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import SurveyService from "../../../Services/Survey.service";
const makeSearchArgs = {
    loadOptions: (search, options) => SurveyService.search(Object.assign({ query: search }, options)).then(({ data }) => {
        return data;
    }),
    label: "displayName",
    value: "id",
};
export const SurveySearch = makeSearch(makeSearchArgs);
export const SurveyMultiSearch = makeMultiSearch(makeSearchArgs);
